import React from 'react';
import { useDarkMode } from '../../context/DarkModeContext';
const PrivacyPolicy = () => {
  const {
    darkMode
  } = useDarkMode();
  return <div className={`min-h-screen ${darkMode ? 'bg-gray-900 text-gray-100' : 'bg-gray-50 text-gray-900'} py-12`} data-id="element-10123" data-mp="v5unb6nx7i3m">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-10124" data-mp="19x39t6wj0ncj">
        <h1 className="text-3xl font-bold mb-2" data-id="element-10125" data-mp="14wpdgm4af1uc">Privacy Policy</h1>
        <p className={`text-sm mb-8 ${darkMode ? 'text-gray-400' : 'text-gray-500'}`} data-id="element-10126" data-mp="h63852lo3vo1">
          Last updated: October 25, 2023
        </p>

        <div className={`prose ${darkMode ? 'prose-invert' : ''} max-w-none`} data-id="element-10127" data-mp="c9mextzm2r43">
          <p data-id="element-10128" data-mp="q8m6b9eidk3y">
            At LitLaunch, we take your privacy seriously. This Privacy Policy
            explains how we collect, use, disclose, and safeguard your
            information when you visit our website or use our services.
          </p>

          <h3 data-id="element-10129" data-mp="1xle5zwra1yuh">1. Information We Collect</h3>
          <p data-id="element-10130" data-mp="1xkbdjkeb3ocg">
            We collect information that you provide directly to us, such as when
            you create an account, make a purchase, or contact us for support.
            This may include:
          </p>
          <ul data-id="element-10131" data-mp="rfbrc5vx0two">
            <li data-id="element-10132" data-mp="vesz55yte350">Name and contact information</li>
            <li data-id="element-10133" data-mp="vg44393zxgxp">Billing and shipping addresses</li>
            <li data-id="element-10134" data-mp="10dx6dr26hqsp">
              Payment information (processed securely by our payment providers)
            </li>
            <li data-id="element-10135" data-mp="3nwj5whgjidi">Reading preferences and history</li>
          </ul>

          <h3 data-id="element-10136" data-mp="3ljxp9chqpvp">2. How We Use Your Information</h3>
          <p data-id="element-10137" data-mp="7oglrfksve71">We use the information we collect to:</p>
          <ul data-id="element-10138" data-mp="7mvnbevd7b3w">
            <li data-id="element-10139" data-mp="cob773lt3bkp">Process your orders and manage your account</li>
            <li data-id="element-10140" data-mp="cn083h3b2rzx">Personalize your reading recommendations</li>
            <li data-id="element-10141" data-mp="hfb3q7r0jrmo">
              Send you updates, newsletters, and promotional materials (which
              you can opt out of)
            </li>
            <li data-id="element-10142" data-mp="3g2yxpsdv3dvx">Improve our website and services</li>
          </ul>

          <h3 data-id="element-10143" data-mp="3l2tmnqe2ttec">3. Information Sharing</h3>
          <p data-id="element-10144" data-mp="3l1s0oqvivmhu">
            We do not sell your personal information. We may share your
            information with third-party service providers who perform services
            on our behalf, such as payment processing, shipping, and data
            analysis.
          </p>

          <h3 data-id="element-10145" data-mp="1116g2vwbqy0s">4. Your Rights</h3>
          <p data-id="element-10146" data-mp="x0cqly38hb5s">
            You have the right to access, correct, or delete your personal
            information. You can manage your account settings directly or
            contact us for assistance.
          </p>

          <h3 data-id="element-10147" data-mp="4c8jr98xes1i">5. Contact Us</h3>
          <p data-id="element-10148" data-mp="4d0fck2iwprs">
            If you have any questions about this Privacy Policy, please contact
            us at privacy@litlaunch.com.
          </p>
        </div>
      </div>
    </div>;
};
export default PrivacyPolicy;